"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COUPON_TYPE = exports.COUPON_DISCOUNT_TYPE = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var CouponDownloadListItem_1 = tslib_1.__importDefault(require("./CouponDownloadListItem"));

var styles = tslib_1.__importStar(require("./CouponDownloadList.style"));

var Spinner_1 = tslib_1.__importDefault(require("../Spinner"));

var ErrorMessage_1 = tslib_1.__importDefault(require("../ErrorMessage"));

var COUPON_DISCOUNT_TYPE;

(function (COUPON_DISCOUNT_TYPE) {
  COUPON_DISCOUNT_TYPE["FLAT"] = "FLAT";
  COUPON_DISCOUNT_TYPE["RATE"] = "RATE";
})(COUPON_DISCOUNT_TYPE = exports.COUPON_DISCOUNT_TYPE || (exports.COUPON_DISCOUNT_TYPE = {}));

var COUPON_TYPE;

(function (COUPON_TYPE) {
  COUPON_TYPE["DIRECT_COUPON"] = "DIRECT_COUPON";
  COUPON_TYPE["REDEEM_CODE_COUPON"] = "REDEEM_CODE_COUPON";
  COUPON_TYPE["PROMOTION_CODE_COUPON"] = "PROMOTION_CODE_COUPON";
})(COUPON_TYPE = exports.COUPON_TYPE || (exports.COUPON_TYPE = {}));

function CouponDownloadList(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      coupons = _ref.coupons,
      applyCouponDownload = _ref.applyCouponDownload;

  function handleCouponClick(id, type) {
    return function () {
      applyCouponDownload(id, type);
    };
  }

  if (isLoading) {
    return jsx_runtime_1.jsx("div", Object.assign({
      css: styles.loadingContainer
    }, {
      children: jsx_runtime_1.jsx(Spinner_1.default, {}, void 0)
    }), void 0);
  }

  if (hasError) {
    return jsx_runtime_1.jsx(ErrorMessage_1.default, {
      title: "\uC77C\uC2DC\uC801\uC73C\uB85C \uC815\uBCF4\uB97C \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694.",
      content: "\uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCCD0 \uBCF4\uC138\uC694.",
      buttonText: "\uC0C8\uB85C\uACE0\uCE68",
      onClick: function onClick() {
        return window.location.reload();
      }
    }, void 0);
  }

  if (!coupons.length) {
    return jsx_runtime_1.jsx(ErrorMessage_1.default, {
      type: "empty",
      title: "\uB2E4\uC6B4\uB85C\uB4DC \uAC00\uB2A5\uD55C \uCFE0\uD3F0\uC774 \uC5C6\uC5B4\uC694."
    }, void 0);
  }

  return jsx_runtime_1.jsx("div", Object.assign({
    role: "list",
    className: className
  }, {
    children: coupons.map(function (coupon) {
      return jsx_runtime_1.jsx(CouponDownloadListItem_1.default, {
        flatAmount: coupon.flatAmount,
        discountRate: coupon.discountRate,
        name: coupon.name,
        conditions: coupon.condition,
        description: coupon.description,
        expireDate: "",
        discountType: coupon.discountType,
        isUsable: coupon.isUsable,
        applyCouponDownload: handleCouponClick(coupon.id, coupon.couponType)
      }, coupon.id);
    })
  }), void 0);
}

exports.default = CouponDownloadList;